import type { SVGComponentProps } from 'BreetHelpers';

export const RewardPointsAvailablePointsIcon = ({ ...rest }: SVGComponentProps) => (
	<svg
		width='32'
		height='32'
		viewBox='0 0 32 32'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<circle
			cx='16'
			cy='16'
			r='16'
			fill='#E1F1FE'
		/>
		<path
			opacity='0.4'
			d='M21.5233 13.1083L16.3576 16.0969L11.1919 13.1083C11.4205 12.6854 11.7519 12.314 12.1233 12.1083L15.1748 10.4169C15.8262 10.0511 16.889 10.0511 17.5405 10.4169L20.5919 12.1083C20.9633 12.314 21.2948 12.6854 21.5233 13.1083Z'
			fill='#022745'
		/>
		<path
			opacity='0.6'
			d='M16.3574 16.097V21.5713C15.9288 21.5713 15.5003 21.4798 15.1745 21.297L12.1231 19.6055C11.4317 19.2227 10.866 18.2627 10.866 17.4741V14.2398C10.866 13.8741 10.9917 13.4741 11.1917 13.1084L16.3574 16.097Z'
			fill='#022745'
		/>
		<path
			d='M21.8491 14.2398V17.4741C21.8491 18.2627 21.2834 19.2227 20.592 19.6055L17.5405 21.297C17.2148 21.4798 16.7862 21.5713 16.3577 21.5713V16.097L21.5234 13.1084C21.7234 13.4741 21.8491 13.8741 21.8491 14.2398Z'
			fill='#022745'
		/>
	</svg>
);
